import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import Axios from "@/lib/axios-instance";

// Type for the plan creation payload
type UpdatePlanPayload = {
    id: string;
    name?: string;
    price?: string;
    description?: string;
    plans_interval?: string;
    is_active?: boolean;
};

// Mutation function that calls the API
export const updatePlan = async (payload: UpdatePlanPayload) => {
    const { id, ...rest } = payload;

    try {
        const response = await Axios.put(`/plan/${id}`, rest);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

// Custom hook for creating a plan
export const useUpdatePlan = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (payload: UpdatePlanPayload) => updatePlan(payload),
        onSuccess: (data) => {
            queryClient.refetchQueries({ queryKey: ["get-all-feature-plans"] }); // Adjust query key if needed
            queryClient.refetchQueries({ queryKey: ["get-plan"] }); // Adjust query key if needed
            toast.success("Plan updated successfully.");
            console.log({ data });
        },
        onError: (error: Error) => {
            toast.error("Unable to create plan.", { description: error.message });
            console.error({ error });
        },
    });
};
